/* eslint-disable */
import React, { useContext, useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
// import DateInputPicker from 'modules/common/components/DateInputPicker';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import {
  EXTENSION_NAMES,
  GENDER,
  RELATIONSHIPS,
  WHAT_TO_PRINT,
  YES_OR_NO,
} from 'modules/civil-registry/constant';
import * as actions from '../action';
import * as c from '../constant';

function UpdateModal({
  createInput,
  createSelect,
  createInputDate,
  createTinNumber,
  createTelephoneNumber,
  createInputMobileNumber,
  createSelectAddress,
  createInputMask,
  createSelectCountry,
  createSelectHospital,
  updateBirthCertificate,
  showTransaction,
  formData,
  updateList,
  setFormData,
  id,
  updating,
  getTransactionList,
  filter,
  getPurposeList,
  purposeList,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateBirthCertificate(id, formData, () => {
      setModal({ isOpen: false });
      showTransaction(id);
      getTransactionList(filter);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  // const handleOnChangeDate =
  //   (key) =>
  //   ({ target: { value } }) => {
  //     setFormData({
  //       ...formData,
  //       [key]: value,
  //     });
  //   };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      setFormData(_.pick(updateList, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, [updateList]);

  useEffect(() => {
    getPurposeList();
  }, []);

  const purposeOptions = useMemo(() => {
    if (!purposeList) return [];
    return _.map(purposeList, (item) => ({
      value: item.attributes.code,
      label: item.attributes.name,
    }));
  }, [purposeList]);

  const isCountryCodeRequired = useMemo(() => {
    if (!formData.purpose_code || isEmpty(purposeList)) return false;
    const purposeInfo = purposeList.find(
      (purpose) => purpose.attributes.code === formData.purpose_code
    );
    return Boolean(_.get(purposeInfo, 'attributes.with_country_code'));
  }, [formData.purpose_code, purposeList]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <p className="col-12 font-weight-bold">
            Owner&apos;s Personal Information
          </p>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              { key: 'first_name', label: 'First Name:' },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              { key: 'middle_name', label: 'Middle Name:' },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              { key: 'last_name', label: 'Last Name:' },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Extension Name',
                key: 'extension_name',
                label: 'Extension Name',
              },
              EXTENSION_NAMES
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Sex',
                key: 'gender',
                label: 'Sex',
              },
              GENDER
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInputDate({
              required: true,
              key: 'birth_date',
              label: 'Date of Birth',
            })}
          </div>

          <p className="col-12 font-weight-bold mt-3">
            Owner&apos;s Father&apos;s Name
          </p>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                key: 'fathers_first_name',
                label: `First Name:`,
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                key: 'fathers_middle_name',
                label: `Middle Name:`,
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                key: 'fathers_last_name',
                label: `Last Name:`,
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                key: 'fathers_suffix_name',
                label: `Extension Name`,
              },
              EXTENSION_NAMES
            )}
          </div>

          <p className="col-12 font-weight-bold mt-3">
            Owner&apos;s Mother&apos;s Maiden Name
          </p>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                required: true,
                key: 'mothers_first_name',
                label: 'First Name:',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                key: 'mothers_middle_name',
                label: 'Middle Name:',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                required: true,
                key: 'mothers_last_name',
                label: 'Last Name:',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                key: 'mothers_extension_name',
                label: `Extension Name`,
              },
              EXTENSION_NAMES
            )}
          </div>

          <p className="col-12 font-weight-bold mt-3">
            Requestor&apos;s Information
          </p>
          <div className="col-sm-12 col-md-6 form-group">
            {createTinNumber(
              {
                required: true,
                key: 'tin_number',
                label: 'Tax Identification Number (TIN):',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                key: 'relationship_to_the_owner',
                label: 'Relationship to the owner:',
              },
              RELATIONSHIPS.sort((a, b) => a.label.localeCompare(b.label))
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                required: true,
                key: 'requestors_first_name',
                label: 'First Name:',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                key: 'requestors_middle_name',
                label: 'Middle Name:',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                required: true,
                key: 'requestors_last_name',
                label: 'Last Name:',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                key: 'requestors_suffix_name',
                label: `Extension Name`,
              },
              EXTENSION_NAMES
            )}
          </div>
          <label className="col-12">Place of birth</label>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('place_region', {
              required: true,
              key: 'place_of_birth_region_code',
              label: `Region`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('place_province', {
              required: true,
              key: 'place_of_birth_province_code',
              label: `Province`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('place_municipality', {
              required: true,
              key: 'place_of_birth_municipality_code',
              label: `City/Municipality`,
            })}
          </div>
          <p className="col-12 font-weight-bold mt-3">Mailing Address</p>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('region', {
              required: true,
              key: 'region_code',
              label: `Region`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('province', {
              required: true,
              key: 'province_code',
              label: `Province`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('municipality', {
              required: true,
              key: 'municipality_code',
              label: `City/Municipality`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('barangay', {
              required: true,
              key: 'barangay_code',
              label: `Barangay`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                key: 'street',
                label: `Unit/Room No./Floor, Building Name, House No., Street Name`,
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInputMask(
              {
                key: 'mailing_zip_code',
                label: `Zip Code`,
              },
              '9999'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createTelephoneNumber({
              key: 'telephone_number',
              label: `Telephone No.`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInputMobileNumber({
              key: 'mobile_number',
              label: `Mobile No.`,
            })}
          </div>

          <p className="col-12 font-weight-bold mt-3">
            Transactional Information
          </p>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectCountry({
              required: true,
              key: 'born_abroad_country_code',
              label: `Please specify country if born abroad only`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput({
              key: 'bren',
              label: `Birth Registry Number (BReN) if known`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectHospital({
              required: true,
              key: 'hospital_code',
              label: `Hospital Name`,
            })}
          </div>
          {_.get(formData, 'hospital_code') === 'OTHER' ? (
            <div className="col-sm-12 col-md-6 form-group">
              {createInput(
                {
                  key: 'hospital_other',
                  label: `Hospital Name / Name of Midwife/Hilot (if born home/clinic)`,
                },
                {},
                'form-control-uppercase'
              )}
            </div>
          ) : (
            <></>
          )}
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                key: 'is_registered_late',
                label: `Registered Late? (if Yes)`,
              },
              YES_OR_NO
            )}
          </div>
          {_.get(formData, 'is_registered_late') ? (
            <div className="col-sm-12 col-md-6 form-group">
              {createInputDate({
                required: true,
                key: 'registered_when',
                label: 'Registered when?',
              })}
            </div>
          ) : (
            <></>
          )}
          <div className="col-sm-12 col-md-6 form-group">
            {createInputMask(
              {
                required: true,
                key: 'number_of_copies',
                label: `No. of Copies`,
              },
              '999'
            )}
          </div>
          {/* <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                key: 'what_to_print',
                label: `What to Print`,
              },
              WHAT_TO_PRINT
            )}
          </div> */}
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                key: 'purpose_code',
                label: `Purpose`,
              },
              purposeOptions
            )}
          </div>
          {isCountryCodeRequired ? (
            <div className="col-sm-12 col-md-6 form-group">
              {createSelectCountry({
                required: true,
                key: 'purpose_country_code',
                label: `Purpose Specify Country`,
              })}
            </div>
          ) : (
            <></>
          )}
          {_.get(formData, 'purpose_code') === 'OTHER' ? (
            <div className="col-sm-12 col-md-6 form-group">
              {createInput({
                required: true,
                key: 'purpose_specify',
                label: `Purpose Specify`,
              })}
            </div>
          ) : (
            <></>
          )}
          {/* <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                key: 'valid_id_to_present',
                label: `Valid ID to Present Upon Claiming`,
              },
              VALID_IDS
            )}
          </div> */}
          {/* <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                key: 'delivery_option',
                label: `Delivery Option`,
              },
              commonC.EXTENSION_NAMES
            )}
          </div> */}
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  createInputDate: PropTypes.instanceOf(Function).isRequired,
  createTinNumber: PropTypes.instanceOf(Function).isRequired,
  createTelephoneNumber: PropTypes.instanceOf(Function).isRequired,
  createInputMobileNumber: PropTypes.instanceOf(Function).isRequired,
  createSelectAddress: PropTypes.instanceOf(Function).isRequired,
  createInputMask: PropTypes.instanceOf(Function).isRequired,
  createSelectCountry: PropTypes.instanceOf(Function).isRequired,
  createSelectHospital: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  updateBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  filter: PropTypes.instanceOf(Object).isRequired,
  getPurposeList: PropTypes.instanceOf(Function).isRequired,
  purposeList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.EDIT_BIRTH) > -1,
  purposeList: _.get(api, `${c.GET_PURPOSE_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
